// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.preview-message {\r\n  white-space: pre-wrap;\r\n  border: 1px solid #000;\r\n  border-radius: 4px;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\n}\n.preview-textbox input {\r\n  color: #000 !important;\n}\n.preview-textbox .v-input__slot {\r\n  color: #000 !important;\r\n  border: 1px solid #000;\r\n  border-radius: 4px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
